// client/src/ui/RadioManager.js
window.RadioManager = {
    init: function () {
        const modal = document.getElementById('radio-modal');
        const closeBtn = document.getElementById('close-radio-btn');
        
        // Listen for open button click (Delegation because it's in a screen)
        document.addEventListener('click', (e) => {
            if (e.target.closest('#radio-open-btn')) {
                this.open();
            }
        });

        if (modal && closeBtn) {
            closeBtn.addEventListener('click', () => this.close());

            // Close on outside click
            modal.addEventListener('click', (e) => {
                if (e.target === modal) this.close();
            });
        }
    },

    open: function () {
        const modal = document.getElementById('radio-modal');
        if (modal) {
            modal.classList.remove('hidden');
            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');
            
            // [A11Y] Focus Trap
            if (window.AccessibilityManager) {
                window.AccessibilityManager.trapFocus(modal);
            }
        }
    },

    close: function () {
        const modal = document.getElementById('radio-modal');
        if (modal) {
            modal.classList.add('hidden');
            if (window.AccessibilityManager) window.AccessibilityManager.releaseFocus();
        }
    }
};
